import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const zkSyncMainnet: VToken[] = [
  {
    chainId: 324,
    address: '0xAF8fD83cFCbe963211FAaf1847F0F217F80B4719',
    decimals: 8,
    symbol: 'vWBTC_Core',
    underlyingToken: tokens[324][3],
  },
  {
    chainId: 324,
    address: '0x1Fa916C27c7C2c4602124A14C77Dbb40a5FF1BE8',
    decimals: 8,
    symbol: 'vWETH_Core',
    underlyingToken: tokens[324][2],
  },
  {
    chainId: 324,
    address: '0x1aF23bD57c62A99C59aD48236553D0Dd11e49D2D',
    decimals: 8,
    symbol: 'vUSDC.e_Core',
    underlyingToken: tokens[324][5],
  },
  {
    chainId: 324,
    address: '0x69cDA960E3b20DFD480866fFfd377Ebe40bd0A46',
    decimals: 8,
    symbol: 'vUSDT_Core',
    underlyingToken: tokens[324][4],
  },
  {
    chainId: 324,
    address: '0x697a70779C1A03Ba2BD28b7627a902BFf831b616',
    decimals: 8,
    symbol: 'vZK_Core',
    underlyingToken: tokens[324][7],
  },
  {
    chainId: 324,
    address: '0x84064c058F2EFea4AB648bB6Bd7e40f83fFDe39a',
    decimals: 8,
    symbol: 'vUSDC_Core',
    underlyingToken: tokens[324][6],
  },
  {
    chainId: 324,
    address: '0x183dE3C349fCf546aAe925E1c7F364EA6FB4033c',
    decimals: 8,
    symbol: 'vwUSDM_Core',
    underlyingToken: tokens[324][8],
  },
  {
    chainId: 324,
    address: '0x03CAd66259f7F34EE075f8B62D133563D249eDa4',
    decimals: 8,
    symbol: 'vwstETH_Core',
    underlyingToken: tokens[324][9],
  },
  {
    chainId: 324,
    address: '0xCEb7Da150d16aCE58F090754feF2775C23C8b631',
    decimals: 8,
    symbol: 'vzkETH_Core',
    underlyingToken: tokens[324][10],
  },
];
